// Generated from the approved MagicPath revision 440504637448146944. Do not hand-edit; update the source worktree instead.
import { FormEvent, useEffect, useState } from 'react';
const doorPlate = "/assets/page11-door.jpg";
const navigation = ['METHOD', 'HOUSE 45', 'INSIGHTS', 'ASSESSMENT'];
type Page11TheDoorProps = { assessmentRequest?: number };
export const Page11TheDoor = ({ assessmentRequest = 0 }: Page11TheDoorProps) => {
  const [activeNav, setActiveNav] = useState('METHOD');
  const [assessment, setAssessment] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    if (assessmentRequest > 0) setAssessment(true);
  }, [assessmentRequest]);
  const submit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSubmitted(true);
  };
  return <main className="door-page">
    <img className="door-photo" src={doorPlate} alt="Warm dawn above mountains and a sea of clouds" />
    <div className="door-grade" aria-hidden="true" />
    <button className="door-wordmark" type="button" aria-label="IMTHEHOUSE home">IMTHEHOUSE</button>
    <nav className="door-navigation" aria-label="Primary navigation">
      {navigation.map(item => <button key={item} type="button" className={activeNav === item ? 'active' : ''} onClick={() => setActiveNav(item)} aria-pressed={activeNav === item}>{item}</button>)}
    </nav>

    {!assessment && <section className="door-copy" aria-labelledby="door-heading">
      <h1 id="door-heading">STOP GIVING THEM<br />THE EDGE.</h1>
      <p>One private call. What’s going on, what it’s costing you,<br />whether we’re the right fit.<br />No scripts. If we’re not right for you, we’ll say so.</p>
      <button className="door-primary-cta" type="button" onClick={() => setAssessment(true)}>BEGIN THE PRIVATE ASSESSMENT <span aria-hidden="true">→</span></button>
      <small>Confidential. Direct. No obligation on either side.</small>
    </section>}

    {assessment && !submitted && <form className="door-assessment" onSubmit={submit}>
      <h1>BEGIN THE PRIVATE ASSESSMENT</h1>
      <div><input required aria-label="Name" placeholder="NAME" /><input required type="email" aria-label="Contact email" placeholder="CONTACT" /></div>
      <textarea required aria-label="What is happening" placeholder="ONE LINE ON WHAT’S HAPPENING" />
      <div><input required aria-label="How long" placeholder="HOW LONG" /><input required aria-label="Why now" placeholder="WHY NOW" /></div>
      <button type="submit">REQUEST A PRIVATE CONVERSATION →</button>
    </form>}
    {submitted && <div className="door-assessment door-complete" role="status"><h1>YOU’RE IN THE RIGHT ROOM.</h1><p>We’ll take it from here.</p></div>}

    <footer className="door-footer"><strong>11 / 11</strong><span>THE DOOR</span><i aria-hidden="true" /></footer>
  </main>;
};
